import { Link } from "react-router-dom";
import { ShieldCheck, Globe, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

export function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || "fr").split("-")[0];
  const toggle = () => i18n.changeLanguage(current === "fr" ? "en" : "fr");
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="lang-switch"
      title={t("nav.language")}
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] font-semibold uppercase tracking-widest text-slate-700 hover:border-slate-400"
    >
      <Globe className="h-3.5 w-3.5" />
      {current === "fr" ? "FR / EN" : "EN / FR"}
    </button>
  );
}

export function BrandMark({ className = "" }) {
  const { t } = useTranslation();
  return (
    <Link to="/" className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-mark">
      <img src="https://brand.ariovis.fr/logos/Logotype_BLACK.svg" alt="Ariovis — Security Meets Business" className="h-6 md:h-7 w-auto" />
      <span className="hidden md:inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-600">
        <ShieldCheck className="h-3 w-3 text-brand-fuchsia" />
        {t("brand.tag")}
      </span>
    </Link>
  );
}

export function TopBar() {
  const { t } = useTranslation();
  return (
    <header className="w-full border-b border-slate-200 bg-white/85 backdrop-blur sticky top-0 z-30">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <BrandMark />
        <nav className="flex items-center gap-2 md:gap-4 text-sm text-slate-700">
          <LanguageSwitch />
          <a
            href="https://ariovis.fr/produits"
            className="hidden md:inline-flex items-center gap-1 hover:text-slate-950 transition-colors"
            data-testid="nav-back-produits"
          >
            {t("nav.back_products")} <ExternalLink className="h-3 w-3" />
          </a>
          <a
            href="https://ariovis.fr"
            className="hidden md:inline-flex items-center gap-1 hover:text-slate-950 transition-colors"
            data-testid="nav-back-ariovis"
          >
            ariovis.fr <ExternalLink className="h-3 w-3" />
          </a>
        </nav>
      </div>
    </header>
  );
}

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="text-xs text-slate-500 leading-relaxed max-w-2xl">
          {t("footer.legal")}
        </div>
        <div className="flex items-center gap-4 text-sm text-slate-600">
          <a href="https://ariovis.fr/produits" className="hover:text-slate-950" data-testid="footer-back-produits">
            {t("nav.back_products")}
          </a>
          <span className="text-slate-300">·</span>
          <a href="https://ariovis.fr" className="hover:text-slate-950" data-testid="footer-back-ariovis">
            ariovis.fr
          </a>
        </div>
      </div>
    </footer>
  );
}
